var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotBlankPage',{attrs:{"maxWidth":"calc(100% - 80px)","hasBackLink":true,"failLink":"/new-password/restore","itemKey":"User","fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setBreadcrumbs":_vm.setBreadcrumbs},scopedSlots:_vm._u([{key:"default",fn:function({
        Item
      }){return [_c('Form',{attrs:{"User":Item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }